// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./element-variables.scss
// module id = 1580
// module chunks = 228